import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import publicMethods from '@mixin/publicMethods';
import { AccountStorage, Account } from "@services/account";
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      isPostalCashActive: false,
      isPostalCashHistoryActive: false,
      number: undefined,
      maxNumber: 0,
      data: [],
      columns: [{
        field: "time",
        label: "时间"
      }, {
        field: "bank",
        label: "提入银行"
      }, {
        field: "code",
        label: "银行卡号"
      }, {
        field: "number",
        label: "提现金额"
      }],
      totalBalanceAmount: 0,
      dataList: [],
      page: 0,
      pageSize: 10,
      totalPageNumber: 1,
      busy: false,
      bottomTitle: "",
      isExternal: false,
      isSubmitApply: false,
      pointsMoney: 0,
      accData: {},
      hbdata: [],
      mothdata: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      yeardata: [],
      year: "",
      month: "",
      arrearsData: {} //欠款信息
    };
  },
  computed: {
    hasBankCard: function hasBankCard() {
      return true;
    }
  },
  mixins: [publicMethods],
  mounted: function mounted() {
    var userInfo = accountStorage.getCacheUserInfo();
    if (userInfo) {
      this.isExternal = userInfo.type == 1 ? true : false;
    }
    this.getBalancePageList();
    var year = new Date().getFullYear();
    var month = new Date().getMonth() + 1;
    var yeardata = [];
    for (var i = 0; i < 10; i++) {
      yeardata.push(year - i + "");
    }
    this.yeardata = yeardata;
    this.year = new Date().getFullYear();
    //修改月份判断 > 为 >=  10.13 hy
    this.month = month >= 10 ? month + "" : "0" + month;
    this.getaccountTail();
    this.getArrears();
  },
  methods: {
    //获取欠款
    getArrears: function getArrears() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var account, URL, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              account = accountStorage.getCacheUserInfo().account;
              URL = "/pjyy-deepexi-erp-api-center/api/v1/erp/creditStanding/".concat(account);
              _context.next = 4;
              return _this.$getHttpClient().get(URL);
            case 4:
              result = _context.sent;
              if (result.data.code == 200) {
                _this.arrearsData = result.data.data;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //立即还款
    nowArrears: function nowArrears() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var account, URL, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              account = accountStorage.getCacheUserInfo().account;
              URL = "/pjyy-deepexi-pay-center/rpc/v2/openPay/getWebPayLink1?erpId=".concat(account, "&orderSource=5");
              _context2.next = 4;
              return _this2.$getHttpClient().get(URL);
            case 4:
              result = _context2.sent;
              if (result.data.code == 200) {
                window.open(result.data.data);
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getaccountTail: function getaccountTail() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, _res$data, code, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$getHttpClient().get("/pjyy-deepexi-user-center/rpc/api/v1/balance/selectAllRedDetailsPage?time=" + _this3.year + "-" + _this3.month);
            case 2:
              res = _context3.sent;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === "200") {
                data.forEach(function (item) {
                  var arr = item.time.split('.');
                  item.time = arr[0];
                });
                _this3.hbdata = data;
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onPostalCash: function onPostalCash() {
      this.number = "";
      this.isPostalCashActive = true;
    },
    onSubmit: function onSubmit(props) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var url, params, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/pjyy-deepexi-user-center/api/v1/balance/withdrawal";
              params = {
                withdrawalAmount: _this4.number
              };
              _context4.next = 4;
              return _this4.$getHttpClient().post(url, params);
            case 4:
              res = _context4.sent;
              if (res.data.code == "200") {
                _this4.applyResult = res.data.data;
                props.close();
                // 提现成功之后重置数据
                _this4.number = 0;
                _this4.dataList = [];
                _this4.page = 0;
                _this4.getBalancePageList();
                _this4.isSubmitApply = true;
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 上拉加载更多
    loadMore: function loadMore() {
      //先不做 兴趣推荐 防止重复请求数据 1 代表排行榜
      this.busy = true;
      if (this.page < this.totalPageNumber) {
        this.bottomTitle = "正在加载...";
        this.getBalancePageList();
      }
    },
    formatNum: function formatNum(num) {
      if (num && Number(num)) {
        return Number(num).toFixed(2);
      } else {
        return "0.00";
      }
    }
  }
};